import { render, staticRenderFns } from "./serviceTemplate.vue?vue&type=template&id=70c7d74c&"
import script from "./serviceTemplate.vue?vue&type=script&lang=js&"
export * from "./serviceTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports